module.exports = __webpack_public_path__ + "static/media/error.4570110e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/coupon/images/error.svg
// module id = 1566
// module chunks = 0